var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "field-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.feature.image,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "field-box-title heading-3-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.feature.title)
    }
  }), _vm._l(_vm.feature.values, function (value) {
    return _c('div', {
      staticClass: "field-box-row"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "paragraph-1-large",
      domProps: {
        "innerHTML": _vm._s(value.name)
      }
    })]);
  })], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "asset-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/accept-red.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }